//Generated File 
export default class ApprovalInitiators{
	static readonly BudgetExceededDelete = `BudgetExceededDelete`;
	static readonly BudgetExceededSave = `BudgetExceededSave`;
	static readonly Commit = `Commit`;
	static readonly Delete = `Delete`;
}
